"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var api_request_1 = require("../../api_request");
var alt_1 = require("../../alt");
var user_helper_1 = require("../user_helper");
var constants_1 = require("../../shared/constants");
var url_helpers_1 = require("../../shared/url_helpers");
var user_store_1 = require("../../../reverb-js-common/user_store");
var PAGE_SIZE = 12;
var ComparisonShoppingPageActions = /** @class */ (function () {
    function ComparisonShoppingPageActions() {
    }
    ComparisonShoppingPageActions.prototype.errored = function () {
        return null;
    };
    ComparisonShoppingPageActions.prototype.preloadClear = function () {
        return null;
    };
    ComparisonShoppingPageActions.prototype.loaded = function (response) {
        return response;
    };
    ComparisonShoppingPageActions.prototype.clear = function () {
        return null;
    };
    ComparisonShoppingPageActions.prototype.fetchForSupportedRegions = function (_a) {
        var query = _a.query, params = _a.params;
        if (!user_helper_1.cspShippingRegionSupported(user_store_1.default.getState().shippingRegionCode)) {
            return null;
        }
        var fetchParams = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, query), params), { page: 1, per_page: PAGE_SIZE });
        this.fetch(fetchParams);
        return null;
    };
    ComparisonShoppingPageActions.prototype.loading = function () {
        return true;
    };
    ComparisonShoppingPageActions.prototype.fetch = function (params) {
        var _this = this;
        var requestParams = tslib_1.__assign({}, params);
        this.loading();
        if (!user_helper_1.cspShippingRegionSupported(user_store_1.default.getState().shippingRegionCode)) {
            // returns global pricing and counts instead of region-specific ones
            requestParams.ships_to = constants_1.default.EVERYWHERE_CODE;
        }
        var req = api_request_1.default.V3.get(url_helpers_1.default.cspsPath(), requestParams);
        req.then(function (response) {
            _this.loaded(response);
        });
        req.fail(function (_xhr, status, err) {
            _this.errored();
            throw new Error("could not fetch CSPs - status: " + status + ", err: " + err);
        });
        return null;
    };
    return ComparisonShoppingPageActions;
}());
exports.default = alt_1.default.createActions(ComparisonShoppingPageActions);
//# sourceMappingURL=csp_actions.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/csp/csp_actions.js
// module id = aqlS
// module chunks = 20 21